export enum TransactionAccessType {
    Overview = 'Overview',
    Structure = 'Structure',
    TargetPortfolio = 'TargetPortfolio',
    ExportTargetPortfolio = 'ExportTargetPortfolio',
    Documents = 'Documents',
    Deal = 'Deal',
    Iois = 'Iois',
    ComparableDeals = 'ComparableDeals',
    PortfolioStatistics = 'PortfolioStatistics',
}

export enum TransactionAnalyticCollectingActions {
    ComparableDealsDeal = 'ComparableDealsDeal',
    ComparableDealsManager = 'ComparableDealsManager',
    ComparableDealsArranger = 'ComparableDealsArranger',
}

export type TransactionAccessTypeCollecting = TransactionAccessType | TransactionAnalyticCollectingActions;

export const TransactionAccessTypes = [
    { value: TransactionAccessType.Overview, text: 'Overview', color: '#235692' },
    { value: TransactionAccessType.Structure, text: 'Structure', color: '#669FC3' },
    { value: TransactionAccessType.PortfolioStatistics, text: 'Portfolio Statistics', color: '#5BBED8' },
    { value: TransactionAccessType.TargetPortfolio, text: 'Target Portfolio', color: '#AFE0EB' },
    { value: TransactionAccessType.ComparableDeals, text: 'Comparative Metrics', color: '#205EFF' },
    { value: TransactionAccessType.Documents, text: 'Documents', color: '#CECECE' },
    { value: TransactionAccessType.Iois, text: 'IOIs', color: '#9B9B9B' },
];
